import script from "./BlogBreadcrumb.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogBreadcrumb.vue?vue&type=script&setup=true&lang=ts"

import "../../assets/css/blog-breadcrumb.css?vue&type=style&index=0&id=05cd22c4&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05cd22c4"]])

export default __exports__